import { ChatInput } from "./2_ChatInput";
import { MessageList } from "./1_MessageList";

import "../../styles/ChatPageLayout.css"

export const ChatPageLayout = () => {
  return (
    <div>
      <div className="chat-window">
        <div className="messages-container">
          <MessageList />
        </div>

        <div className="user-input-container">
          <ChatInput />
        </div>
      </div>
    </div>
  );
};

export default ChatPageLayout;